/** Backend contract: add-ons use blocked_reason; Guided uses data.error_code. */
export const isRetiredPlanError = (
    error: unknown,
    allowLegacyConflict = false
): boolean => {
    if (typeof error !== "object" || error === null || !("response" in error)) {
        return false;
    }

    const { response } = error;
    if (
        typeof response !== "object" ||
        response === null ||
        !("status" in response)
    ) {
        return false;
    }
    if (allowLegacyConflict && response.status === 409) return true;
    if (response.status !== 422 || !("data" in response)) return false;

    const body = response.data;
    if (typeof body !== "object" || body === null) return false;

    if ("blocked_reason" in body && body.blocked_reason === "plan_retired") {
        return true;
    }

    if (
        !("data" in body) ||
        typeof body.data !== "object" ||
        body.data === null
    ) {
        return false;
    }

    return "error_code" in body.data && body.data.error_code === "PLAN_RETIRED";
};
